/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { ILxsHeroHeaderViewProps } from './lxs-hero-header';
import * as MsDyn365 from '@msdyn365-commerce/core';

export default (props: ILxsHeroHeaderViewProps) => {
    const CLASS_NAME = 'lxs-hero-header';
    const { config, context } = props;
    const { backgroundImage, heading, leftContent, rightContent } = config;

    return (
        <div className={CLASS_NAME}>
            <div className={`${CLASS_NAME}__background`}>
                {backgroundImage && (
                    <MsDyn365.Image
                        {...backgroundImage}
                        className={`${CLASS_NAME}__image`}
                        gridSettings={context.request.gridSettings!}
                        imageSettings={backgroundImage.imageSettings}
                    />
                )}
            </div>

            <div className={`${CLASS_NAME}__content-wrapper`}>
                <div className={`${CLASS_NAME}__content-box`}>
                    {heading && <h1 className={`${CLASS_NAME}__heading`}>{heading}</h1>}

                    <div className={`${CLASS_NAME}__columns`}>
                        <div className={`${CLASS_NAME}__column--left`}>
                            {leftContent && <MsDyn365.RichTextComponent text={leftContent} />}
                        </div>

                        <div className={`${CLASS_NAME}__column--right`}>
                            {rightContent && <MsDyn365.RichTextComponent text={rightContent} />}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
